export default "__VITE_ASSET__7da9d8f6__"